export enum StudentsListField {
  NAME = 'NAME',
  EMAIL = 'EMAIL',
  INACTIVE_DAYS = 'INACTIVE_DAYS',
  LAST_ACTIVITY = 'LAST_ACTIVITY',
  PLAN_TYPE = 'PLAN_TYPE',
  PRIVATE_CLASSES = 'PRIVATE_CLASSES',
  STATUS = 'STATUS',
  EXPIRATION = 'EXPIRATION',
  ASSIGN_REASSIGN = 'ASSIGN_REASSIGN',
  SELECT = 'SELECT',
  SETTINGS = 'SETTINGS',
  LICENSE_NAME = 'LICENSE_NAME',
  WEEKLY_GOAL_PERCENTAGE = 'WEEKLY_GOAL_PERCENTAGE',
  WEEKLY_ACTIVITY_PERCENTAGE = 'WEEKLY_ACTIVITY_PERCENTAGE',
}
